var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 3.90244C2.825 3.90244 3.5 3.22744 3.5 2.40244C3.5 1.57744 2.825 0.902435 2 0.902435C1.175 0.902435 0.5 1.57744 0.5 2.40244C0.5 3.22744 1.175 3.90244 2 3.90244ZM2 5.40244C1.175 5.40244 0.5 6.07744 0.5 6.90244C0.5 7.72744 1.175 8.40244 2 8.40244C2.825 8.40244 3.5 7.72744 3.5 6.90244C3.5 6.07744 2.825 5.40244 2 5.40244ZM2 9.90244C1.175 9.90244 0.5 10.5774 0.5 11.4024C0.5 12.2274 1.175 12.9024 2 12.9024C2.825 12.9024 3.5 12.2274 3.5 11.4024C3.5 10.5774 2.825 9.90244 2 9.90244Z",
    fill: "#000348"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/Dropdown.fd4e4b71360b680d8e22cda23484cd7d.svg";
export { ForwardRef as ReactComponent };